@if (compData | async; as cmsData) {
  @if(cmsData.uid == 'profile-paymentInformation-component'){
    <div class="col-md-11 col-sm-12 col-12 padding-right-5 myprofile_flex_cdc myprofile_flex_items"
      id="myProfilepage">
      <div class="myprofile_membership paymentcontainer">
        <div class="col-xs-12 myprofile_paymentmanage">
          <a class="anchorunderline" [routerLink]="['/payment-information']"
            >{{cmsData.urlLink}}</a
            >
            <div
              [routerLink]="['/payment-information']"
              class="global_blackarrow paymentarrow"
            ></div>
          </div>
          <div class="myprofile_tophybrisheader">{{cmsData.title}}</div>
          @if (paymentDetails; as item) {
            @if (item.hasSavedCard) {
              <div
                class="margin-T20 myprofile_hybrisheader"
                >
                {{cmsData.subcontent}}
              </div>
            }
            @if (!item?.hasSavedCard && !item?.hasExpiredCard) {
              <div
                class="margin-T20 myprofile_hybrisheader"
                >
                {{cmsData.content}}
              </div>
            }
            @if (item?.hasExpiredCard) {
              <div
                class="margin-T10 myprofile_hybrisheader paymentexpire"
                >
                <img
                  src="/assets/images/exclamation-mark.png"
                  class="financial_alertImg padding-R10"
                  />
                  {{"profile.cardexpiredmsg" | cxTranslate}}
                </div>
              }
            }
          </div>
        </div>
      } @else if(cmsData.uid == 'SeqirusAutoRolloverComponent'){
        <app-custom-autorollover [cmsContent]="cmsData"></app-custom-autorollover>
        }@else if(cmsData.uid == 'auto-alertprofile-component'){
        <app-custom-autorolloversucess-alert [cmsContent]="cmsData"></app-custom-autorolloversucess-alert>
      }
    }
